import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-url-not-found',
    templateUrl: './url-not-found.component.html'
})
export class UrlNotFoundComponent implements OnInit {

    public url: string;

    constructor(private router: Router) {

        this.url = router.url;
     }

    ngOnInit() {
    }

}
